import type { ReactNode } from 'react'
import {
  Card,
  CardHeader,
  CardTitle,
  CardTitleCount,
  CardContent,
} from '@/components/Card'
import styles from './InfoLinesCard.module.css'

interface InfoLineProps {
  title: string
  children: ReactNode
}

function InfoLine({ title, children }: InfoLineProps) {
  return (
    <div className={styles.infoLinesItem}>
      <div className={styles.infoLinesItemLabel}>{title}</div>
      <div className={styles.infoLinesItemValue}>{children}</div>
    </div>
  )
}

export interface InfoLinesCardProps {
  infoLines: { title: string; content: string }[]
}

export function InfoLinesCard({ infoLines }: InfoLinesCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          Info lines
          <CardTitleCount>({infoLines.length})</CardTitleCount>
        </CardTitle>
      </CardHeader>
      <CardContent scroll>
        {infoLines.map((line, i) => (
          <InfoLine key={i} title={line.title}>
            {line.content}
          </InfoLine>
        ))}
      </CardContent>
    </Card>
  )
}
